const DEFAULT_TIMEOUT = 4000  

class CartAnnouncements extends HTMLElement {
  #announcementEl
  #timeout

  constructor() {
    super()

    this.#announcementEl = this.querySelector('div')

    this.announceCartUpdate = this.announceCartUpdate.bind(this)
    this.handleCartAdd = this.handleCartAdd.bind(this)
    this.handleCartUpdate = this.handleCartUpdate.bind(this)
    this.handleCartLoaded = this.handleCartLoaded.bind(this)
  }

  announceCartUpdate(msg) {
    if (this.#timeout) clearTimeout(this.#timeout)

    this.#announcementEl.innerHTML = msg

    this.#timeout = setTimeout(() => {
      this.#announcementEl.innerHTML = ''
    }, DEFAULT_TIMEOUT)
  }

  handleCartAdd(cart) {
    // Handle direct items array (from cart add response)
    if (cart?.items && Array.isArray(cart.items)) {
      const items = cart.items
      if (items.length === 1) {
        const item = items[0]
        const productName = item.product_title || item.title || 'Product'
        this.announceCartUpdate(`${productName} added to cart`)
      } else {
        this.announceCartUpdate(`${items.length} items added to cart`)
      }
      return
    }
    // Handle single item objects (legacy format)
    if (cart?.product_title || cart?.title) {
      const productName = cart.product_title || cart.title || 'Product'
      this.announceCartUpdate(`${productName} added to cart`)
      return
    }
    // Fallback announcement
    this.announceCartUpdate('Item added to cart')
  }

  handleCartUpdate(cart) {
    if (cart && cart.item_count !== undefined) {
      const itemCount = cart.item_count
      if (itemCount === 0) {
        this.announceCartUpdate('Cart is now empty')
      } else {
        this.announceCartUpdate(`Cart updated. ${itemCount} item${itemCount !== 1 ? 's' : ''} in cart`)
      }
    }
  }

  handleCartLoaded(e) {
    const { cart, type } = e.detail

    if (['ADD'].includes(type)) this.handleCartAdd(cart)
    else this.handleCartUpdate(cart)
  }

  // This part is specific to each shopify store.
  connectedCallback() {
    document.addEventListener('on:cart:loaded', this.handleCartLoaded)

    // document.addEventListener('on:cart:add', handleCartAdd)
    // document.addEventListener('on:cart:update', handleCartUpdate)
  }
  disconnectedCallback() {
    document.removeEventListener('on:cart:loaded', this.handleCartLoaded)

    // document.removeEventListener('cart:add', handleCartAdd)
    // document.removeEventListener('cart:update', handleCartUpdate)
    if (this.#timeout) clearTimeout(this.#timeout)
  }
}
customElements.define('cart-announcements', CartAnnouncements)
